import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import HamburgerButton from './HamburgerButton.vue'
@Component({
    components: { HamburgerButton }
})
export default class PageHeaderWithActionBar extends Vue {
    @Prop({ type: String }) title!: string
}